<template>
  <div>
    <el-upload
      ref='upload'
      class='upload-demo'
      :action='uploadUrlNew'
      :auto-upload='true'
      :show-file-list='false'
      :data='uploadData'
      :on-success='planOnSuccess'
      :before-upload='beforeUpload'
    >
      <el-button v-if='isButton' type='primary' :size='buttonSize'>{{ uploadText }}</el-button>
      <i v-else class='el-icon-upload el-icon--right'
         style=' color: rgba(51, 136, 255, 1);'>{{ uploadText }}</i>
    </el-upload>

    <success-tips ref='successTipsRef' />
  </div>
</template>

<script>
  import { getImport } from '@/service/getIP';
  import SuccessTips from './successTips';

  export default {
    name: 'waterBatchImport',
    components: { SuccessTips },
    props: {
      //  导入地址
      uploadUrl: {
        type: String,
        default: '',
      },
      uploadText: {
        type: String,
        default: '批量导入',
      },
      isButton: {
        type: Boolean,
        default: false,
      },
      buttonSize: {
        type: String,
        default: 'mini',
      },
    },
    data() {
      return {
        uploadData: {
          mFile: '',//文件名
        },
        uploadUrlNew: getImport(this.uploadUrl),
      };
    },
    methods: {
      /**
       *导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.$emit('triggerLoading');
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$refs.successTipsRef.dialogOpen(res.data);
        // this.$alert(`${res.message}\n${res.message}` || '导入成功', '提示', {
        //   confirmButtonText: '关闭',
        //   callback: async () => {
        //     this.$emit('importSuccess', res.data || res);
        //   },
        // });
      },
      beforeUpload(file) {
        // console.log(file)
        const arr = file.name.split('.');
        if (arr[arr.length - 1] === 'xls' || arr[arr.length - 1] === 'xlsx') {
          this.$emit('triggerLoading');
          this.uploadData.mFile = file.name;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  .upload-demo {
    padding-right: 10px;
  }
</style>
